import React from "react";
import { generatePath, Link, useLocation } from "react-router-dom";

import { ACCOUNT_ROUTES } from "../../pages";

export function AccountIdLinkCell({ accountId }: { accountId: number }) {
  const { pathname } = useLocation();

  return (
    <Link
      className="tw-w-full tw-text-inherit hover:tw-underline"
      to={generatePath(`${pathname}${ACCOUNT_ROUTES.details}`, {
        accountId,
      })}
    >
      {accountId}
    </Link>
  );
}
